const ALL_ENTITIES = [
  'Technician',
  'Ticket',
  'User',
  'TechnicianGroup',
  'Requester',
  'Approval',
  'Task',
  'Client',
  'Project',
  'Site',
  'SLA',
  'Employee',
  'ClientUser',
  'Designation',
  'BusinessFunction',
  'RequesterAssociation',
  'Team',
  'Role',
  'Inviter',
  'Alert',
  'Asset',
  'Policy',
  'AssetCPUMemData',
  'AssetScript',
  'OutgoingMailSettings',
  'AccountManager',
  'PrimaryContact',
  'SecondaryContact',
  'ReportingManager',
  'Chart',
  'Report',
  'Worklog',
  'OfferedItem',
  'ServiceItem',
  'Invoice',
  'IPAsset',
  'WorkStation',
  'PatchDetail',
  'CurrentApproval',
  'CurrentNote',
  'CurrentReply',
  'ProjectOwner',
  'PatchKb',
  'Account',
  'AssetClass',
  'AssetPatchDetail',
  'AssetSoftwareInventory',
  'AssetSoftware',
  'CommunityScript',
  'PatchHealth',
  'AntiVirusHealth',
  'DataBackupHealth',
  'HoursWorklogEntry',
  'HoursServiceItem',
  'WorkItem',
  'Email',
  'FeedbackSurveyResponse',
  'FeedbackSurvey',
  'MonitoredAsset'
];

export { ALL_ENTITIES };
